import { NgModule } from '@angular/core';

import { SharedModule } from "../shared/shared.module";
import { EstruturasComponent } from './estruturas.component';
import { EnderecosModule } from "./enderecos/enderecos.module";
import { LocalidadesModule } from "./localidades/localidades.module";
import { OrgaosModule } from "./orgaos/orgaos.module";
import { AreasModule } from "./areas/areas.module";
import { DivisoesModule } from "./divisoes/divisoes.module";
import { SetoresModule } from "./setores/setores.module";
import { EstruturasRoutingModule } from "./estruturas-routing.module";


@NgModule({
  imports: [
    SharedModule,
    EnderecosModule,
    LocalidadesModule,
    OrgaosModule,
    AreasModule,
    DivisoesModule,
    SetoresModule,
    EstruturasRoutingModule
  ],
  declarations: [
    EstruturasComponent
  ]
})
export class EstruturasModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/estruturas.module.ts
 **/